import { render, staticRenderFns } from "./marketDetail2.vue?vue&type=template&id=8d09b2a6&scoped=true&lang=pug&"
import script from "./marketDetail2.vue?vue&type=script&lang=js&"
export * from "./marketDetail2.vue?vue&type=script&lang=js&"
import style0 from "./marketDetail2.vue?vue&type=style&index=0&lang=less&"
import style1 from "./marketDetail2.vue?vue&type=style&index=1&id=8d09b2a6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d09b2a6",
  null
  
)

export default component.exports